// src/components/RouteErrorBoundary.tsx
import React from "react";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

// Fängt Fehler beim Laden lazy geladener Routen ab (z. B. fehlgeschlagener Chunk),
// damit nicht die ganze App leer bleibt.
export class RouteErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("Route konnte nicht geladen werden:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center" style={{ background: "#f5f3ea", color: "#173d30" }}>
        <p style={{ fontSize: 15, fontWeight: 600 }}>Diese Seite konnte nicht geladen werden.</p>
        <p style={{ fontSize: 13, color: "#5e6d60" }}>Bitte lade die Seite neu. Falls der Fehler bleibt, versuche es später erneut.</p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: "8px 16px", borderRadius: 9, background: "#ddf2a2", color: "#111", fontSize: 13, fontWeight: 600, border: "none", cursor: "pointer" }}
        >
          Seite neu laden
        </button>
      </div>
    );
  }
}
